// 模板 18：法律服务与合规咨询机构官网

export default {
  home: {
    banners: [
      {
        img: require('@/assets/img/banner2.jpg'),
        path: '',
        title: '面向企业的综合法律服务',
        content:
          '为企业提供商业合同、投融资与合规等全方位法律支持。'
      },
      {
        img: require('@/assets/img/banner_1.jpg'),
        path: '',
        title: '专业合规顾问团队',
        content:
          '帮助企业识别合规风险，构建管理体系。'
      }
    ],
    bigData: {
      img: require('@/assets/img/about_img.png'),
      title: '案件与合规项目管理平台',
      subtitle: '/ Legal & Compliance Management',
      paragraphs: [
        '通过系统化管理案件与合规项目，提高团队协作效率与服务质量。',
        '沉淀知识与经验，为后续案件提供参考与支持。'
      ],
      buttonText: '预约法律顾问'
    },
    contact: {
      title: '企业的长期法律伙伴',
      subTitle: '在快速变化的环境中守护企业安全发展',
      buttonText: '立即咨询'
    },
    customers: [],
    advantages: []
  },
  company: {
    name: '衡正律师事务所',
    aboutImg: require('@/assets/img/about_img.png'),
    paragraphs: [
      '__COMPANY_NAME__长期服务于科技、制造与金融等多个行业客户，为企业提供切实可行的法律解决方案。',
      '我们相信专业、稳健与务实，是法律服务的核心价值。'
    ]
  },
  news: [
    {
      id: 'LAW01',
      title: '发布数据合规指南',
      introduce:
        '结合最新法规与实务经验，为企业提供数据合规落地建议。',
      date: '11-18',
      year: '2024'
    },
    {
      id: 'LAW02',
      title: '成功协助多家企业完成股权激励项目',
      introduce:
        '在合规前提下帮助企业制定灵活有效的激励方案。',
      date: '07-05',
      year: '2024'
    },
    {
      id: 'LAW03',
      title: '举办企业合规管理专题培训',
      introduce:
        '面向中小企业 HR 与法务负责人分享合规管理实践。',
      date: '03-22',
      year: '2024'
    },
    {
      id: 'LAW04',
      title: '多名律师入选行业榜单',
      introduce:
        '在公司法与争议解决等多个领域获得专业认可。',
      date: '10-09',
      year: '2023'
    },
    {
      id: 'LAW05',
      title: '上线在线法律咨询平台',
      introduce:
        '为中小企业提供更加便捷的日常法律咨询渠道。',
      date: '05-14',
      year: '2023'
    }
  ],
  software: {
    smartTown: {
      title: '案件与客户管理系统',
      sections: [
        {
          heading: '1. 客户信息管理',
          content:
            '集中管理企业客户信息与历史服务记录。'
        },
        {
          heading: '2. 案件进度跟踪',
          content:
            '记录案件节点与重要文书，保障信息完整。'
        },
        {
          heading: '3. 工时与费用记录',
          content:
            '按项目记录律师工时与费用，为结算与分析提供基础。'
        },
        {
          heading: '4. 内部知识库',
          content:
            '沉淀办案文书与研究成果，提升团队整体专业水平。'
        }
      ]
    },
    bigData: {
      title: '合规项目管理平台',
      sections: [
        {
          heading: '1. 项目计划与任务分解',
          desc:
            '明确合规项目的阶段与责任人，保障执行有序。'
        },
        {
          heading: '2. 风险清单与整改跟踪',
          desc:
            '记录识别出的风险点与整改进度，保证闭环。'
        },
        {
          heading: '3. 合规培训记录',
          desc:
            '管理员工参与合规培训与考试情况，为审计提供依据。'
        },
        {
          heading: '4. 报告与归档',
          desc:
            '统一存储合规报告与支撑材料，方便查阅。'
        }
      ]
    }
  },
  services: [
    {
      id: 'section-1',
      title: '常年法律顾问',
      engTitle: 'General Counsel',
      img: require('@/assets/img/service1.jpg')
    },
    {
      id: 'section-2',
      title: '合规管理咨询',
      engTitle: 'Compliance Consulting',
      img: require('@/assets/img/service2.jpg')
    },
    {
      id: 'section-3',
      title: '争议解决与仲裁',
      engTitle: 'Dispute Resolution',
      img: require('@/assets/img/service3.jpg')
    },
    {
      id: 'section-4',
      title: '专项法务培训',
      engTitle: 'Legal Training',
      img: require('@/assets/img/service4.jpg')
    }
  ],
  job: {
    title: '公司法律业务律师',
    responsibilities: [
      '为企业客户提供日常法律咨询与合同审核服务；',
      '参与股权、投融资与合规项目的方案设计与执行；',
      '撰写研究文章与客户简报，分享专业观点。'
    ],
    requirements: [
      '具有法律执业资格，有公司法或合规经验优先；',
      '具备扎实的法律基础与逻辑能力；',
      '具备良好的沟通能力与服务意识。'
    ],
    buttonText: '加入我们'
  }
};





// WEBPACK FOOTER //
// ./src/config/templates-18.js